const styles = {
  container: {
    height: '100%',
    backgroundColor: '#f4f4f4',
    border: '1px solid #cfcfcf',
  },
  gridContainer: {
    height: '100%',
    flexWrap: 'nowrap',
  },
  assignmentDetailMap: {
    // flex: 1,
    height: '225px',
    maxWidth: '100%',
    overflow: 'auto',
    minHeight: '225px',
  },
  shipmentDetail: {
    // flex: 3,
    maxWidth: '100%',
    // maxHeight: '330px',
    borderTop: '1px solid #cfcfcf',
    backgroundColor: '#fff',
    overflow: 'hidden',
  },
};

export default styles;
